import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowUp = () => {
  return (
    <g>
      <path d="m14.57 6.2844-6.04-6.04a.75.75 0 0 0 -1.0605 0l-6.04 6.04a.75.75 0 0 0 1.0605 1.0606l4.76-4.7597v12.64a.75.75 0 0 0 1.5 0v-12.6401l4.76 4.76a.75.75 0 1 0 1.06-1.0608z" />
    </g>
  );
};

export default withIcon(IconArrowUp);
